import React from "react";
import type { FocusEvent } from "react";
import U2000InputTagBase from "./U2000InputTagBase";
import type { U2000FormStateHandlers } from "../../../reducer/formReducer/U2000FormStateHandlers";

interface U2000InputTagAlphanumProps {
  formStateHandlers: U2000FormStateHandlers<any>;
  fieldName: string;
  label: string;
  readonly?: boolean;
  required?: boolean;
  icon?: React.ReactNode;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  formatter?: (val: string) => string;
  placeholder?: string;
}

/**
 * Filtre la saisie pour ne garder que les caractères alphanumériques, tiret et espace.
 * @param {string} val - Valeur saisie
 * @returns {string} Chaine filtrée
 */
function filterByType(val: string): string {
  return val.replace(/[^a-zA-Z0-9- ]/g, "");
}

const U2000InputTagAlphanum: React.FC<U2000InputTagAlphanumProps> = (props) => {
  return <U2000InputTagBase {...props} filterFunction={filterByType} />;
};

export default U2000InputTagAlphanum;
